import { useNavigate } from "react-router-dom";
import "./LuckyGame.css";
const RestrictionCard = () => {
  const navigate = useNavigate();
  return (
    <div className="popup-overlay">
      <div
        className="card text-white bg-danger mb-3"
        style={{ maxWidth: "90%" }}
      >
        <div className="card-header">Mễ Mễ Việt Nam xin thông báo</div>
        <div className="card-body">
          <h5 className="card-title text-center">
            "Chương trình vòng quay may mắn đã kết thúc"
          </h5>
          <p className="card-text text-center">
            "Hẹn gặp lại bạn trong những chương trình tiếp theo."
          </p>
          <div className="d-flex justify-content-center">
            <button className="btn btn-warning" onClick={() => navigate("/")}>
              Về trang chủ
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default RestrictionCard;
